import React, {useEffect, useMemo, useState} from 'react'
import {premioFields, mapPremioToTable} from "./premio-fields"
import {Paper} from "@mui/material"
import DynamicColumnTable from "../../../componentes/dynamic-column-table"
import PropTypes from "prop-types"
import {copyTable, pasteTableFromClipboard} from "../../../../utils/csv-utils"
import {useLocation} from "react-router-dom"
import MotorPremioService from "../../../../../../../services/motor-premio-service"

const PremioTable = ({
                         setLoading,
                         idCaracteristica,
                         eventoPublicado,
                         tableData,
                         setTableData,
                         clearTable
                     }) => {

    const service = useMemo(() => new MotorPremioService(), [])
    const [tableKey, setTableKey] = useState(Math.random() * 10)
    const location = useLocation()
    const navigationState = location.state

    useEffect(() => {
        if (!idCaracteristica) return

        const {origem} = navigationState
        if (origem === "ver") {
            loadPremio()
        }
    }, [idCaracteristica])

    useEffect(() => {
        const {origem} = navigationState
        if (origem === "duplicar") {
            const {data} = navigationState
            const {premio} = data
            setTableData(mapPremioToTable(premio))
        }
    }, [])

    const loadPremio = () => {
        setLoading(true)
        console.log(eventoPublicado)

        service.getPremio(idCaracteristica)
            .then(response => {
                const {body} = response

                if (body && body.length > 0) {
                    eventoPublicado(true)
                    const formatted = mapPremioToTable(body)
                    setTableData(formatted)
                    setTableKey(Math.random() * 10)
                } else {
                    loadPremioTemporario()
                }
            })
            .catch(error => console.error("Erro getPremio:", error))
            .finally(() => setLoading(false))
    }

    const loadPremioTemporario = () => {
        setLoading(true)

        service.getTemporarioPremio(idCaracteristica)
            .then(response => {
                const bodyTemp = response?.body || response?.data

                if (bodyTemp) {
                    eventoPublicado(false)

                    // Extrair array de Premio do objeto temporário
                    const premios = Array.isArray(bodyTemp)
                        ? bodyTemp
                        : bodyTemp?.Premios || []

                    const formatted = mapPremioToTable(premios)

                    setTableData(formatted)
                    setTableKey(Math.random() * 10)
                } else {
                    console.warn("Nenhum dado temporário encontrado")
                }
            })
            .catch(error => console.error("Erro getTemporarioPremio:", error))
            .finally(() => setLoading(false))
    }

    return (
        <Paper sx={{mt: 2}}>
            <DynamicColumnTable
                key={tableKey}
                actionButtons={true}
                copyData={() => copyTable(tableData, premioFields)}
                pasteData={async () => await pasteTableFromClipboard(premioFields, setTableData)}
                clearTable={() => clearTable(setTableData)}
                fields={premioFields}
                items={tableData}
                setItems={setTableData}
            />
        </Paper>
    )
}

PremioTable.propTypes = {
    setLoading: PropTypes.bool,
    idCaracteristica: PropTypes.number,
    eventoPublicado: PropTypes.func,
    tableData: PropTypes.array,
    setTableData: PropTypes.func,
    clearTable: PropTypes.func,
}

export default PremioTable